import { PredictionLabelType } from '@modules/feedback/types';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import {
  EntityLabel,
  ReasonLabel,
  SearchLabel,
  SentimentLabel,
} from 'v2/core/entities/feedback/labels';
import { MatchedFeedbackMetadataCommon } from 'v2/core/entities/labels';

export const getCombinedMatchedMetadataFromLabels = (
  labels: FeedbackLabel[],
): MatchedFeedbackMetadataCommon[] => {
  const entityLabels = (labels as EntityLabel[])?.filter(
    (label): label is EntityLabel => !!label.entityUnits,
  );
  const reasonLabels = (labels as ReasonLabel[])?.filter(
    (label) => !!label.reasonUnits,
  );

  const searchLabels = (labels as SearchLabel[])?.filter(
    (label) => !!label.matches,
  );

  const sentimentLabels = (labels as SentimentLabel[])?.filter(
    (label) => !!label.sentimentUnits,
  );

  const allLabelUnits: MatchedFeedbackMetadataCommon[] = [];

  entityLabels.forEach((label) => {
    label.entityUnits?.forEach((unit) => {
      allLabelUnits.push({
        ...unit,
        id: label.id,
        labelType: PredictionLabelType.Entity,
        labelText: label.displayName,
        sentiment: label.aggregatedSentiment,
        keywordSummary: label.keywordSummary,
      });
    });
  });

  reasonLabels.forEach((label) => {
    label.reasonUnits?.forEach((unit) => {
      allLabelUnits.push({
        ...unit,
        id: label.id,
        labelType: PredictionLabelType.Reason,
        labelText: label.displayName,
      });
    });
  });

  searchLabels.forEach((label) => {
    label.matches?.forEach((unit) => {
      allLabelUnits.push({
        ...unit,
        id: label.id,
        labelType: PredictionLabelType.Search,
        labelText: label.displayName,
      });
    });
  });

  sentimentLabels.forEach((label) => {
    // Show only the units which has the same sentiment
    // as the overall feedback record.
    const unitsWithCorrectSentiment = label.sentimentUnits?.filter(
      (unit) => unit.sentiment === label.displayName,
    );

    unitsWithCorrectSentiment?.forEach((unit) => {
      allLabelUnits.push({
        ...unit,
        id: label.id,
        labelType: PredictionLabelType.Sentiment,
        labelText: label.displayName,
      });
    });
  });

  return allLabelUnits.filter(
    (labelUnit, index, labelUnits) =>
      labelUnits.findIndex(
        (l) =>
          l.id === labelUnit.id &&
          l.msgIDx === labelUnit.msgIDx &&
          l.startIDx === labelUnit.startIDx &&
          l.endIDx === labelUnit.endIDx &&
          l.keywordSummaryLabelID === labelUnit.keywordSummaryLabelID,
      ) === index,
  ); // filter out duplicate label match units
};
